function getEl(): HTMLElement | null {
  return typeof document !== 'undefined'
    ? document.getElementById('narrator-caption')
    : null
}

export function showCaption(text: string): void {
  const el = getEl()
  if (!el) return
  el.textContent = text
  el.style.transition = 'opacity 0.2s ease-in'
  el.style.opacity = '1'
}

export function hideCaption(fadeOutSec = 0.5): void {
  const el = getEl()
  if (!el) return
  el.style.transition = `opacity ${fadeOutSec}s ease-out`
  el.style.opacity = '0'
}
